<template>
  <div class="navBar">
    <div class="left mainBlue" @click="goHome">
      {{value==='en'?'Cross-Border Pmt Bus. Sys.':'跨境支付业务系统'}}
    </div>
    <div class="right">
      <el-image class="user_logo" :src="require('@/assets/images/tel.png')" />
      <span class="contactMsg">400-670-0808（8:30-22:00）</span>
      <el-image class="user_logo" :src="require('@/assets/images/email.png')" />
      <span class="contactMsg">kjyy@easypay.com.cn</span>
      <el-select style="margin: 0 15px;width: 110px" class="zh_en" v-model="value" placeholder="选择语言" @change="switchChange">
        <el-option label="中文" value="zh"></el-option>
        <el-option label="English" value="en"></el-option>
      </el-select>
      <el-image class="user_logo" :src="require('@/assets/images/user.png')" />
      <p class="user_p">
        <span class="userName">Hi, {{ userAccount }}</span><br>
        <span class="userName">ID: {{ merchantNumber }}</span>
      </p>
      <div class="flex_center_column system_setting" @click="goSetting">
        <el-image :src="require('@/assets/images/setting.png')" />
        <span> {{value==='en'?'Settings':'设置'}}</span>
      </div>
      <div class="flex_center_column mainBlue" @click="logout">
        <el-image :src="require('@/assets/images/exit.png')" />
        <span>{{value==='en'?'Exit':'退出'}}</span>
      </div>
    </div>
    <!-- <NotCertified :showNotCertifi="showNotCertifi" @closeModel="closeModel" /> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getLoginId,setLanguage,getLanguage } from '@/utils/auth'
import { parseTime } from '@/utils'
import { CommonService } from '@/api'
// import NotCertified from '@/components/NotCertifiedModel'
export default {
  name: 'NavBar',
  props: {
  },
  components: {
    // NotCertified
  },
  computed: {
    ...mapState({
      user: state => state.user,
    }),
  },
  watch: {
    "user.operatorStatus"() {
      this.setUserAccount()
    }
  },
  data() {
    return {
      messageList: [],
      showNotCertifi: false,
      userAccount: '',
      merchantNumber:'',
      value:getLanguage()||'zh',
    }
  },
  created() {
    // this.userName = getName()

    if (!this.userAccount) {
      this.setUserAccount()
    }
    this.merchantNumber=window.localStorage.getItem('merchantNumber')
  },
  methods: {
    setUserAccount() {
      this.userAccount = this.user.operatorStatus === 'om_approved' ? this.user.name : getLoginId()
    },
    goSetting() {
      this.$router.push('/setting')
    },
    showCertifyModel() {
      this.showNotCertifi = true
    },
    closeModel() {
      this.showNotCertifi = false
    },
    logout() {
      this.$store.dispatch('user/logout').then(res => {
        // 自动保存功能
        // window.sessionStorage.removeItem('temporaryData')
        // let intervalIdArr = JSON.parse(window.sessionStorage.getItem('tempIntervalIdArr'))
        // if (intervalIdArr){
        //   for(var i = 0; i < intervalIdArr.length; i++){
        //     clearInterval(intervalIdArr[i])
        //   }
        //   window.sessionStorage.removeItem('tempIntervalIdArr')
        // }
        this.$router.push('/login')
      }).catch(() => {
        this.$router.push('/login')
      })
    },
    goHome(e) {
      // this.$router.push('/')
    },
    switchChange() {
      setLanguage(this.value)
      this.$router.go(0)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "~@/styles/variables.scss";
.navBar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  overflow: hidden;
  justify-content: space-between;
  padding: 0 30px;
  height: $navBarHeight;
  z-index: 1001;
  box-shadow:0px 5px 10px 0px rgba(232,232,235,0.5);
  background: #fff;
  .left{
    font-size: 20px;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-weight: 700;
  }
  .right{
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #132F62;
    .user_logo {
      width: 24px;
      margin-right: 12px;
      max-width:100% !important;
    }
    .user_p{
      span{
        display: block;
        line-height: 3px;
      }
    }
    .contactMsg {
      font-size: 14px;
      margin-right: 40px;
      font-weight: 700;
    }
    .flex_center_column {
      margin-left: 30px;
      cursor: pointer;
      &:hover {
        opacity: 0.7;
      }
      .el-image {
        width: 20px;
        margin-bottom: 3px;
      }
      &.system_setting {
        color: #BEBEC8;
      }
    }
  }
}
</style>
